<div class="agent-tests">
  <div class="ats-header">
    <h2 class="ats-title" i18n="@@agentTests.title">Tests</h2>
    <div class="ats-actions">
      <p-button
        snAssistantAnchor="runEvaluationTests"
        i18n-label="@@agentTests.runAll"
        label="Run All Tests"
        icon="pi pi-play"
        severity="secondary"
        [outlined]="true"
        [loading]="isRunningAll()"
        [disabled]="isRunningAll() || attachedRows().length === 0"
        (click)="runAll()">
      </p-button>
      <p-button
        i18n-label="@@agentTests.add"
        label="Add test"
        icon="pi pi-plus"
        [loading]="isAdding()"
        [disabled]="isAdding()"
        (click)="openAddMenu(addMenu, $event)">
      </p-button>
      <p-menu #addMenu [popup]="true" [model]="addMenuItems()" appendTo="body" styleClass="ats-add-menu"></p-menu>
    </div>
  </div>

  <p-tabs [value]="innerTab()" (valueChange)="innerTab.set($any($event))" styleClass="ats-tabs">
    <p-tablist>
      <p-tab value="attached" i18n="@@agentTests.tab.attached">Attached Tests</p-tab>
      <p-tab value="runs" i18n="@@agentTests.tab.runs">Past Test Runs</p-tab>
    </p-tablist>
    <p-tabpanels>

      <!-- Attached tests -->
      <p-tabpanel value="attached">
        <p-table [value]="attachedRows()" [loading]="attachedLoading()" styleClass="ats-table ats-attached">
          <ng-template pTemplate="header">
            <tr>
              <th class="icon-col"></th>
              <th i18n="@@agentTests.col.name">Name</th>
              <th i18n="@@agentTests.col.type">Type</th>
              <th i18n="@@agentTests.col.creator">Creator</th>
              <th i18n="@@agentTests.col.updated">Last updated</th>
              <th class="actions-col"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-row>
            <tr>
              <td class="icon-col">
                <i class="pi pi-arrow-right-arrow-left"></i>
              </td>
              <td>
                @if (row.test) {
                  <a class="ats-name" [routerLink]="['/tests', row.testId]">{{ row.test.name || '-' }}</a>
                } @else {
                  <span class="ats-name muted">{{ row.testId }}</span>
                }
              </td>
              <td>
                @if (row.test?.type) {
                  <p-tag [value]="typeLabel(row.test.type)" severity="info"></p-tag>
                } @else { - }
              </td>
              <td class="muted">{{ row.test?.created_by_email || '-' }}</td>
              <td class="muted">{{ formatDate(row.test?.updated_at) }}</td>
              <td class="actions-col">
                <p-button
                  icon="pi pi-play"
                  [text]="true"
                  severity="secondary"
                  size="small"
                  [loading]="runningRowId() === row.agentTestId"
                  [disabled]="runningRowId() === row.agentTestId"
                  i18n-pTooltip="@@agentTests.runOne"
                  pTooltip="Run test"
                  tooltipPosition="top"
                  (click)="runOne(row)"
                  i18n-ariaLabel="@@agentTests.runOne"
                  ariaLabel="Run test">
                </p-button>
                <p-button
                  icon="pi pi-trash"
                  [text]="true"
                  severity="danger"
                  size="small"
                  i18n-pTooltip="@@common.delete"
                  pTooltip="Delete"
                  tooltipPosition="top"
                  (click)="removeRow(row)"
                  i18n-ariaLabel="@@common.delete"
                  ariaLabel="Delete">
                </p-button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="empty-message" i18n="@@agentTests.empty">
                No tests attached to this agent yet
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabpanel>

      <!-- Past test runs -->
      <p-tabpanel value="runs">
        <p-table [value]="testRuns()" [loading]="runsLoading()" dataKey="id" styleClass="ats-table ats-runs">
          <ng-template pTemplate="header">
            <tr>
              <th class="icon-col"></th>
              <th i18n="@@tests.runs.col.date">Date</th>
              <th i18n="@@tests.runs.col.creator">Started by</th>
              <th i18n="@@tests.runs.col.total">Sessions</th>
              <th i18n="@@tests.runs.col.breakdown">Result</th>
              <th i18n="@@tests.runs.col.status">Status</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-run>
            <tr>
              <td class="icon-col">
                @if (runSessionsLoading()[run.id]) {
                  <i class="pi pi-spin pi-spinner toggler-spinner"></i>
                } @else {
                  <p-button
                    type="button"
                    [text]="true"
                    [rounded]="true"
                    severity="secondary"
                    size="small"
                    [icon]="expandedRows()[run.id] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    (click)="toggleRunExpansion(run)">
                  </p-button>
                }
              </td>
              <td class="muted">{{ formatDate(run.created_at) }}</td>
              <td class="muted">{{ run.created_by_email || '-' }}</td>
              <td
                [pTooltip]="run.test_names?.length ? run.test_names.join('\n') : null"
                tooltipPosition="top"
                [tooltipStyleClass]="'test-names-tt'">
                {{ run.total_sessions ?? 0 }}
              </td>
              <td>
                <div class="run-breakdown">
                  @if (run.success_sessions > 0) {
                    <span class="run-stat ok" i18n-pTooltip="@@tests.runs.success" pTooltip="Success" tooltipPosition="top">
                      <i class="pi pi-check-circle"></i> {{ run.success_sessions }}
                    </span>
                  }
                  @if (run.failed_sessions > 0) {
                    <span class="run-stat fail" i18n-pTooltip="@@tests.runs.failed" pTooltip="Failed" tooltipPosition="top">
                      <i class="pi pi-times-circle"></i> {{ run.failed_sessions }}
                    </span>
                  }
                  @if (run.processing_sessions > 0) {
                    <span class="run-stat proc" i18n-pTooltip="@@tests.runs.processing" pTooltip="Processing" tooltipPosition="top">
                      <i class="pi pi-spin pi-spinner"></i> {{ run.processing_sessions }}
                    </span>
                  }
                  @if ((run.success_sessions ?? 0) === 0 && (run.failed_sessions ?? 0) === 0 && (run.processing_sessions ?? 0) === 0) {
                    <span class="run-stat proc">—</span>
                  }
                </div>
              </td>
              <td>
                <p-tag [value]="runStatusLabel(run)" [severity]="runStatusSeverity(run)"></p-tag>
              </td>
            </tr>

            @if (expandedRows()[run.id] && !runSessionsLoading()[run.id]) {
              @let sessions = sessionsFor(run.id);
              <tr class="run-expansion-row">
                <td colspan="6">
                  @if (sessions.length === 0) {
                    <div class="run-sessions-empty" i18n="@@tests.runs.sessions.empty">No sessions in this run</div>
                  } @else {
                    <table class="run-sessions-table">
                      <thead>
                        <tr>
                          <th i18n="@@tests.runs.sessions.col.date">Session date</th>
                          <th i18n="@@tests.runs.sessions.col.test">Test</th>
                          <th i18n="@@tests.runs.sessions.col.status">Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (s of sessions; track s.id) {
                          <tr class="session-row" [routerLink]="['/agents', agentId(), 'conversations', s.id]">
                            <td>{{ formatDate(s.created_at) }}</td>
                            <td>
                              @if (s.test_id) {
                                <a
                                  [routerLink]="['/tests', s.test_id]"
                                  class="test-link"
                                  (click)="$event.stopPropagation()">
                                  @if (s.test_name) {
                                    {{ s.test_name }}
                                  } @else {
                                    <span i18n="@@tests.runs.sessions.testUnknown">Unknown</span>
                                  }
                                </a>
                              } @else {
                                -
                              }
                            </td>
                            <td>
                              <p-tag [value]="testStatusLabel(s.test_status)" [severity]="testStatusSeverity(s.test_status)"></p-tag>
                            </td>
                            <td class="session-listen" (click)="$event.stopPropagation()">
                              <!-- Идущий e2e-прогон — это живая комната, и
                                   послушать её хочется именно отсюда: на этом
                                   экране сидят, пока тест идёт. Раньше кнопка
                                   была только в карточке разговора, куда ещё
                                   надо догадаться перейти, а к её концу
                                   слушать уже нечего. -->
                              @if (s.status === 'Active') {
                                <app-live-listen-button
                                  [agentId]="agentId()"
                                  [sessionId]="s.id ?? null"
                                  size="small" />
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                </td>
              </tr>
            }
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="empty-message" i18n="@@tests.runs.empty">
                No test runs yet
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
